<template>
    <div class="release-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Registro"
                    sub="Despesa/Receita"
                />
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col xs="12">
                <b-button
                    size="sm"
                    @click="actionNewRelease"
                    variant="dark"
                    title="Adicionar Registro"
                    class="mr-2 fa fa-plus"
                ></b-button>
                <b-button
                    size="sm"
                    @click="loadContracts"
                    v-b-modal.modalContract
                    variant="dark"
                    class="mr-2"
                    >Adicionar com Contrato</b-button
                >
                <b-button
                    size="sm"
                    v-b-modal.modalTypeRelease
                    variant="dark"
                    class="mr-2"
                    >Adicionar por Tipo de Lançamento</b-button
                >
                <b-button
                    size="sm"
                    title="Imprimir"
                    @click="printerRelease"
                    variant="outline-info"
                    class="mr-2"
                    >Lançamento(s)</b-button
                >
                <b-button
                    size="sm"
                    title="Imprimir"
                    @click="printerReleaseOperation"
                    variant="outline-info"
                    class="mr-2"
                    >Lançamento(s) por Operação</b-button
                >
                <b-button
                    size="sm"
                    class="fa"
                    :class="icon"
                    @click="loadReleases()"
                    variant="light"
                ></b-button>
            </b-col>
        </b-row>

        <hr />
        <b-row>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Início:"
                    label-for="release-search-start_date"
                >
                    <b-form-input
                        id="release-search-start_date"
                        type="date"
                        v-model="start_date"
                        v-on:keyup.enter="loadReleases"
                        v-on:keyup.alt.enter="actionNewRelease()"
                        ref="inputsearch"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Data Término:"
                    label-for="release-search-end_date"
                >
                    <b-form-input
                        id="release-search-end_date"
                        type="date"
                        v-model="end_date"
                        v-on:keyup.enter="loadReleases"
                        v-on:keyup.alt.enter="actionNewRelease()"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Nº de Lançamento:"
                    label-for="releasesearch-release_number"
                >
                    <b-form-input
                        id="releasesearch-release_number"
                        v-model="release_number"
                        type="number"
                        size="sm"
                    />
                </b-form-group>
            </b-col>
            <!--b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="release-search-company_id"
                >
                    <b-form-select
                        id="release-search-company_id"
                        @input=";[loadReleases(), loadCostCenter()]"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col!-->
            <b-col md="2" sm="12">
                <b-form-group
                    label="Operação:"
                    label-for="release-search-operation_id"
                >
                    <b-form-select
                        id="release-search-operation_id"
                        @input=";[loadReleases()]"
                        size="sm"
                        :options="operations"
                        v-model="operation_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Status:"
                    label-for="release-search-document_status_id"
                >
                    <b-form-select
                        id="release-search-document_status_id"
                        size="sm"
                        @input="loadReleases"
                        :options="documentstatus"
                        v-model="document_status_id"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="entity-id">
                    <b-form-input
                        id="entity-id"
                        type="text"
                        v-model="entity_id"
                        @input=";[setEntity(), loadReleases()]"
                        @change="loadReleases"
                        v-on:keyup.enter="openModalEntity"
                        v-on:keyup.alt.enter="actionNewRelease()"
                        size="sm"
                        placeholder="Código..."
                    />
                </b-form-group>
            </b-col>
            <b-link
                v-b-modal.modalEntity
                @click="showEntity = true"
                class="fa fa-search mt-4"
            >
            </b-link>
            <b-col md="6" sm="8">
                <b-form-group
                    label="Razão Social:"
                    label-for="entity-name_entity"
                >
                    <b-form-input
                        id="entity-name_entity"
                        type="text"
                        v-model="entity.name_entity"
                        size="sm"
                        :readonly="true"
                        placeholder="Razão Social..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group label="CPF/CNPJ:" label-for="entity-cnpj_cpf">
                    <b-form-input
                        id="entity-cnpj_cpf"
                        type="text"
                        v-model="entity.cnpj_cpf"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>
            <b-link
                v-b-modal.modalRegisterEntity
                class="fa fa-plus mt-4"
            ></b-link>
        </b-row>
        <hr />
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-show="showTable"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            :busy="isBusy"
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            v-show="showTable"
                            hover
                            key="slide"
                            head-variant="light"
                            :items="releases"
                            :fields="fieldsRelease"
                        >
                            <template v-slot:table-busy>
                                <div class="text-center text-info my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Carregando...</strong>
                                </div>
                            </template>
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Editar registro"
                                    size="sm"
                                    variant="light"
                                    @click="actionEditRelease(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button
                                    title="Desconfirmar registro"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 2"
                                    @click="showMsgBoxNotConfirm(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock"></i>
                                </b-button>
                                <b-button
                                    title="Excluir registro"
                                    size="sm"
                                    variant="outline-danger"
                                    v-if="data.item.document_status_id === 1"
                                    @click="
                                        ;[
                                            setRelease(data.item),
                                            showMsgBoxCancel()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-trash"></i>
                                </b-button>
                                <b-button
                                    title="Acesso a Classificação"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 2"
                                    @click=";[openModalOperation(data.item)]"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-server"></i>
                                </b-button>
                                <b-button
                                    title="Acesso a Parcela"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 2"
                                    @click=";[openModalSplot(data.item)]"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-list-alt"></i>
                                </b-button>
                                <b-button
                                    title="Recontabilização"
                                    size="sm"
                                    variant="light"
                                    v-if="data.item.document_status_id === 2"
                                    @click="
                                        ;[
                                            setReleaseAccount(data.item),
                                            showMsgBoxAccounting()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                                <b-button
                                    title="Acesso a Contabilização"
                                    size="sm"
                                    variant="light"
                                    v-b-modal.modalAccounting
                                    v-show="data.item.accounting"
                                    @click="AccountingRelease(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-puzzle-piece"></i>
                                </b-button>
                                <b-button
                                    title="Acesso ao Documento de Entrada"
                                    size="sm"
                                    variant="light"
                                    v-show="data.item.document_entry_id"
                                    @click="actionEditDocumentEntry(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-drivers-license-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalAccounting"
            ref="modal"
            hide-footer
            size="xl"
            title-tag="h6"
            title="Contabilização"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    head-variant="dark"
                    hover
                    striped
                    :items="accountingentrys"
                    :fields="fieldsAccounting"
                >
                </b-table>
            </b-form>
        </b-modal>
        <b-modal
            id="modalContract"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="xl"
            title="Consulta de Contrato(s)"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-card no-body>
                    <b-tabs card small>
                        <b-tab title="Controle por Valor" active>
                            <b-table
                                class="table-responsive"
                                hover
                                striped
                                :items="contractsitemvalues"
                                :fields="fieldsContractValue"
                            >
                                <template slot="actions" slot-scope="data">
                                    <b-button
                                        title="Selecionar o registro"
                                        size="sm"
                                        variant="outline-secondary"
                                        @click="
                                            actionNewReleaseContract(data.item)
                                        "
                                        class="mr-2 mt-2"
                                    >
                                        <i class="fa fa-check-square-o"></i>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-tab>
                        <b-tab title="Controle por Quantidade">
                            <b-table
                                class="table-responsive"
                                hover
                                striped
                                :items="contractsitemquantitys"
                                :fields="fieldsContractQuantity"
                            >
                                <template slot="actions" slot-scope="data">
                                    <b-button
                                        title="Selecionar o registro"
                                        size="sm"
                                        variant="outline-secondary"
                                        @click="
                                            actionNewReleaseContract(data.item)
                                        "
                                        class="mr-2 mt-2"
                                    >
                                        <i class="fa fa-check-square-o"></i>
                                    </b-button>
                                </template>
                            </b-table>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-form>
        </b-modal>
        <b-modal
            id="modalEntity"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Consulta de Cliente/Fornecedor/Banco/Caixa/Aplicação Financeira"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entity.name_entity = $event"
                @setEntityCnpjCpf="entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalEntityTypeRelease"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Consulta de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="setSearchEntityTypeEntity"
        >
            <EntitySearchModal
                @setEntityId="entity_id = $event"
                @setEntityName="entitytype_entity.name_entity = $event"
                @setEntityCnpjCpf="entitytype_entity.cnpj_cpf = $event"
            />
        </b-modal>
        <b-modal
            id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag="h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <EntityModal />
        </b-modal>
        <b-modal
            id="modalTypeRelease"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Registro de Lançamento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveNewRelease"
        >
            <b-form>
                <b-row>
                    <b-col md="9" sm="12">
                        <b-form-group
                            label="Tipo de Lançamento:"
                            label-for="release-type_release_id"
                        >
                            <b-form-select
                                id="release-type_release_id"
                                @input=";[loadTypeRelease()]"
                                size="sm"
                                :options="typereleases"
                                v-model="release.type_release_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        @click="setTypeReleaseRelease"
                        class="fa fa-search mt-4"
                    ></b-link>
                </b-row>
                <b-row>
                    <b-col md="2" sm="2">
                        <b-form-group label="ID" label-for="entity-id">
                            <b-form-input
                                id="entity-id"
                                type="text"
                                v-model="release.entity_id"
                                @input="setEntityTypeRelease()"
                                v-on:keyup.alt.enter="openModalEntity"
                                size="sm"
                                placeholder="Código..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        v-b-modal.modalEntityTypeRelease
                        @click="showEntity = true"
                        class="fa fa-search mt-4"
                    ></b-link>
                    <b-col md="6" sm="8">
                        <b-form-group
                            label="Razão Social:"
                            label-for="entitytype_entity-name_entity"
                        >
                            <b-form-input
                                id="entitytype_entity-name_entity"
                                type="text"
                                v-model="entitytype_entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Razão Social..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ:"
                            label-for="entitytype_entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entitytype_entity-cnpj_cpf"
                                type="text"
                                v-model="entitytype_entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                    <b-link
                        v-b-modal.modalRegisterEntity
                        class="fa fa-plus mt-4"
                    ></b-link>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Data de Emissão:"
                            label-for="release-issue_date"
                        >
                            <b-form-input
                                id="release-issue_date"
                                type="date"
                                title="ALT+H (DATA ATUAL)"
                                v-on:keyup.alt.72="setDateToday"
                                v-model="release.issue_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Nº de Lançamento:"
                            label-for="release-release_number"
                        >
                            <b-form-input
                                id="release-release_number"
                                v-model="release.release_number"
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="release-release_value"
                        >
                            <b-form-input
                                id="release-release_value"
                                v-model="release.release_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Condição:"
                            label-for="release-condition_payment_receipt_id"
                        >
                            <b-form-select
                                id="release-condition_payment_receipt_id"
                                size="sm"
                                :options="conditionpaymentreceipts"
                                v-model="release.condition_payment_receipt_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Forma de Liquidação:"
                            label-for="release-settlement_form_id"
                        >
                            <b-form-select
                                id="release-settlement_form_id"
                                size="sm"
                                :options="settlementforms"
                                v-model="release.settlement_form_id"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalOperations"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="xl"
            title="Classificação do Registro"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-button
                            size="sm"
                            v-b-modal.modalApportionment
                            variant="dark"
                            class="mr-2 mb-2 fa fa-plus"
                        ></b-button>
                        <transition name="slide" type="animation" appear>
                            <b-table
                                class="table-responsive"
                                sticky-header
                                head-variant="light"
                                hover
                                key="slide"
                                :items="releasesapportionments"
                                :fields="fieldsApportionment"
                            >
                                <template v-slot:cell(actions)="data">
                                    <b-button
                                        title="Editar registro"
                                        v-b-modal.modalApportionment
                                        size="sm"
                                        variant="light"
                                        @click="
                                            loadreleasesApportionment(data.item)
                                        "
                                        class="mr-2 mt-2"
                                    >
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="outline-danger"
                                        @click="modeApportionment = 'remove'"
                                        class="mr-2 mt-2"
                                        v-if="modeApportionment === 'insert'"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="light"
                                        @click="
                                            ;[
                                                removeApportionment(data.item),
                                                (modeApportionment = 'insert')
                                            ]
                                        "
                                        class="mr-2 mt-2"
                                        v-if="modeApportionment === 'remove'"
                                    >
                                        <i class="fa fa-check"></i>
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        variant="light"
                                        @click="modeApportionment = 'insert'"
                                        class="mr-2 mt-2"
                                        v-if="modeApportionment === 'remove'"
                                    >
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                    <span
                                        class="mr-2 mt-2"
                                        v-if="modeApportionment === 'remove'"
                                    >
                                        Deseja Excluir o registro?
                                    </span>
                                </template>
                            </b-table>
                        </transition>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalApportionment"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Rateio Custo/Receita"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveApportionment"
        >
            <b-form>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Custo:"
                            label-for="apportionment-apportionment_type_cost_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_type_cost_id"
                                size="sm"
                                :options="typecosts"
                                v-model="
                                    releasesapportionment.apportionment_type_cost_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="1º Nível:"
                            label-for="apportionment-apportionment_operation_level_one_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_operation_level_one_id"
                                @input="loadAppontOperationsLevelTwos"
                                size="sm"
                                :options="operationslevelones"
                                v-model="
                                    releasesapportionment.apportionment_operation_level_one_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="2º Nível:"
                            label-for="apportionment-apportionment_operation_level_two_id"
                        >
                            <b-form-select
                                id="apportionment-apportionment_operation_level_two_id"
                                size="sm"
                                :options="operationsleveltwos"
                                v-model="
                                    releasesapportionment.apportionment_operation_level_two_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="8" sm="12">
                        <b-form-group
                            label="Centro de Custo/Receita:"
                            label-for="releasesapportionment-apportionment_cost_center_id"
                        >
                            <b-form-select
                                id="releasesapportionment-apportionment_cost_center_id"
                                size="sm"
                                :options="costcenters"
                                v-model="
                                    releasesapportionment.apportionment_cost_center_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="%:"
                            label-for="releasesapportionment-apportionment_percent"
                        >
                            <b-form-input
                                id="releasesapportionment-apportionment_percent"
                                v-model="
                                    releasesapportionment.apportionment_percent
                                "
                                type="number"
                                size="sm"
                                @input="apportionmentValue"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Valor:"
                            label-for="releasesapportionment-apportionment_value"
                        >
                            <b-form-input
                                id="releasesapportionment-apportionment_value"
                                v-model="
                                    releasesapportionment.apportionment_value
                                "
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalSplotSearch"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="xl"
            title="Parcelas do Registro"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-table
                            class="table-responsive"
                            sticky-header
                            head-variant="light"
                            hover
                            key="slide"
                            :items="releasesplots"
                            :fields="fieldsSplot"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Editar registro"
                                    v-show="!data.item.closed"
                                    v-b-modal.modalPlots
                                    size="sm"
                                    variant="light"
                                    @click="loadReleasesPlot(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-pencil"></i>
                                </b-button>
                                <b-button
                                    title="Liberar"
                                    size="sm"
                                    v-show="
                                        data.item.blocked && !data.item.closed
                                    "
                                    variant="light"
                                    @click="unblocked(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock"></i>
                                </b-button>
                                <b-button
                                    title="Não Liberar"
                                    size="sm"
                                    v-show="
                                        !data.item.blocked && !data.item.closed
                                    "
                                    variant="light"
                                    @click="blocked(data.item)"
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-unlock-alt"></i>
                                </b-button>
                                <b-button
                                    title="Liquidação"
                                    size="sm"
                                    v-show="
                                        !data.item.blocked && !data.item.closed
                                    "
                                    v-b-modal.modalSettlement
                                    variant="light"
                                    @click="
                                        ;[
                                            loadSettlement(data.item),
                                            loadEntitySettlements()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-money"></i>
                                </b-button>
                                <b-button
                                    title="Cancelar Liquidação"
                                    size="sm"
                                    v-show="data.item.closed"
                                    variant="light"
                                    @click="
                                        ;[
                                            loadSettlementReleaseSplot(
                                                data.item
                                            ),
                                            showMsgBoxCanceled()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-ban"></i>
                                </b-button>
                                <b-button
                                    title="Recontabilização"
                                    size="sm"
                                    variant="light"
                                    v-show="data.item.closed"
                                    @click="
                                        ;[
                                            documentSettlementRelease(
                                                data.item
                                            ),
                                            showMsgBoxAccounting()
                                        ]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-exchange"></i>
                                </b-button>
                            </template>
                            <template v-slot:cell(accesses)="data">
                                <b-button
                                    title="Detalhe da Liquidação"
                                    size="sm"
                                    v-show="data.item.closed"
                                    v-b-modal.modalDocumentSettlement
                                    variant="light"
                                    @click="
                                        ;[documentSettlementRelease(data.item)]
                                    "
                                    class="mr-2 mt-2"
                                >
                                    <i class="fa fa-drivers-license-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalSettlement"
            ref="modal"
            title-tag="h6"
            title="Liquidação"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSettlement"
        >
            <b-form>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="Data de Liquidação:"
                            label-for="documentsettlement-settlement_date"
                        >
                            <b-form-input
                                id="documentsettlement-settlement_date"
                                type="date"
                                v-model="documentsettlement.settlement_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor de Liquidação:"
                            label-for="documentsettlement-settlement_value"
                        >
                            <b-form-input
                                id="documentsettlement-settlement_value"
                                v-model="documentsettlement.settlement_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group
                            label="Conta Banco/Caixa:"
                            label-for="documentsettlement-entity_settlement_id"
                        >
                            <b-form-select
                                id="documentsettlement-entity_settlement_id"
                                size="sm"
                                :options="entitysettlements"
                                v-model="
                                    documentsettlement.entity_settlement_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalDocumentSettlement"
            centered
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Detalhe da Liquidação"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            hide-footer
        >
            <b-form>
                <b-table
                    class="table-responsive"
                    hover
                    striped
                    head-variant="dark"
                    :items="documentsettlements"
                    :fields="fieldsDocumentSettlement"
                ></b-table>
            </b-form>
        </b-modal>
        <b-modal
            id="modalPlots"
            ref="modal"
            title-tag="h6"
            title="Parcelas"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="savePlot"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data de Vencto:"
                            label-for="releasesplot-due_date"
                        >
                            <b-form-input
                                id="releasesplot-due_date"
                                type="date"
                                v-model="releasesplot.due_date"
                                size="sm"
                                :readonly="true"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Data Programada:"
                            label-for="releasesplot-scheduled_date"
                        >
                            <b-form-input
                                id="releasesplot-scheduled_date"
                                type="date"
                                v-model="releasesplot.scheduled_date"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Parcela:"
                            label-for="releasesplot-portion_value"
                        >
                            <b-form-input
                                id="releasesplot-portion_value"
                                v-model="releasesplot.portion_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Multa:"
                            label-for="releasesplot-fine_value"
                        >
                            <b-form-input
                                id="releasesplot-fine_value"
                                v-model="releasesplot.fine_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Juros:"
                            label-for="releasesplot-interest_rate_value"
                        >
                            <b-form-input
                                id="releasesplot-interest_rate_value"
                                v-model="releasesplot.interest_rate_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Desconto:"
                            label-for="releasesplot-discount_value"
                        >
                            <b-form-input
                                id="releasesplot-discount_value"
                                v-model="releasesplot.discount_value"
                                @input="finalValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Valor Final:"
                            label-for="releasesplot-final_value"
                        >
                            <b-form-input
                                id="releasesplot-final_value"
                                v-model="releasesplot.final_value"
                                type="number"
                                size="sm"
                                step="0.02"
                                :readonly="true"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError, searchglobalkey } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
var moment = require('moment-timezone')

export default {
    name: 'ReleaseSearch',
    components: { PageTitle, EntityModal, EntitySearchModal },
    data: function() {
        return {
            mode: 'insert',
            modeRelease: 'insert',
            isBusy: false,
            start_date: null,
            end_date: null,
            document_status_id: null,
            cost_center_id: null,
            company_id: null,
            operation_id: null,
            release_number: null,
            operation_level_one_id: null,
            operation_level_two_id: null,
            entity_id: null,
            searchsetparms: {},
            boxCancel: '',
            release: {},
            releasesplotclosed: {},
            typecosts: [],
            entitysettlements: [],
            operationslevelones: [],
            operationsleveltwos: [],
            documentsettlements: [],
            costcenters: [],
            releases: [],
            documentstatus: [],
            operations: [],
            releasesapportionments: [],
            releasesapportionment: {},
            documentsettlement: {},
            releasesplot: {},
            releasesplots: [],
            entity: {},
            entitytype_entity: {},
            typerelease: {},
            accountingentrys: [],
            contractsitemvalues: [],
            contractsitemquantitys: [],
            companys: [],
            entitysshearch: [],
            typereleases: [],
            conditionpaymentreceipts: [],
            settlementforms: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showRelease: false,
            perPage: 5,
            currentPage: 1,
            fieldsRelease: [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name_operation', label: 'Tipo.', sortable: false },
                {
                    key: 'release_date',
                    label: 'Data Lançamento',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'issue_date',
                    label: 'Data Emissão',
                    sortable: false,
                    variant: 'primary',
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                { key: 'name_reduced', label: 'Tipo Doc.', sortable: false },
                { key: 'serie', label: 'Série.', sortable: false },
                { key: 'release_number', label: 'Nº.', sortable: false },
                { key: 'release_value', label: 'Valor', sortable: false },
                {
                    key: 'name_document_status',
                    label: 'Status',
                    sortable: false
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsAccounting: [
                {
                    key: 'accounting_date',
                    label: 'Contabilizado',
                    sortable: false,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro de Custo/Receita',
                    sortable: false
                },
                {
                    key: 'account_plan',
                    label: 'Conta',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'account_name_plan',
                    label: 'Descrição',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_nature_account',
                    label: 'Nat.',
                    sortable: false,
                    variant: 'light'
                },
                {
                    key: 'accounting_value',
                    label: 'Valor',
                    sortable: false,
                    variant: 'secondary'
                },
                {
                    key: 'accounting_comments',
                    label: 'Histórico',
                    sortable: false
                }
            ],
            fieldsContractValue: [
                { key: 'contract_id', label: 'ID', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: true },
                {
                    key: 'type_time_contract_name',
                    label: 'Tipo',
                    sortable: true
                },
                { key: 'name_operation', label: 'Operação', sortable: false },
                { key: 'complements_name', label: 'Serviço', sortable: false },
                {
                    key: 'contract_item_value_total',
                    label: 'Vr. Contratado',
                    sortable: false
                },
                {
                    key: 'contract_item_value_total_answered',
                    label: 'Vr. Atendido',
                    sortable: false
                },
                {
                    key: 'contract_item_value_total_balance',
                    label: 'Vr. Saldo',
                    sortable: false
                },
                {
                    key: 'contract_internal_number',
                    label: 'Nº Contrato',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsContractQuantity: [
                { key: 'contract_id', label: 'ID', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: true },
                {
                    key: 'type_time_contract_name',
                    label: 'Tipo',
                    sortable: true
                },
                { key: 'name_operation', label: 'Operação', sortable: false },
                { key: 'complements_name', label: 'Serviço', sortable: false },
                {
                    key: 'contract_item_quantity',
                    label: 'Qtde. Contratado',
                    sortable: false
                },
                {
                    key: 'contract_item_quantity_answered',
                    label: 'Qtde. Atendido',
                    sortable: false
                },
                {
                    key: 'contract_item_quantity_balance',
                    label: 'Qtde. Saldo',
                    sortable: false
                },
                {
                    key: 'contract_internal_number',
                    label: 'Nº Contrato',
                    sortable: false
                },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsApportionment: [
                {
                    key: 'name_type_cost',
                    label: 'Custo/Receita',
                    sortable: false
                },
                {
                    key: 'name_cost_center',
                    label: 'Centro Custo/Receita',
                    sortable: false
                },
                {
                    key: 'name_operation_level_two',
                    label: 'Operação',
                    sortable: false
                },
                { key: 'apportionment_percent', label: '%', sortable: false },
                { key: 'apportionment_value', label: 'Valor', sortable: false },
                { key: 'actions', label: 'Ações' }
            ],
            fieldsSplot: [
                {
                    key: 'due_date',
                    label: 'Vencto',
                    sortable: true,
                    variant: 'secondary',
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'scheduled_date',
                    label: 'Programação',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'portion_value', label: 'Vr. Parcela', sortable: false },

                {
                    key: 'final_value',
                    label: 'Vr. Final',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'name_settlement_form',
                    label: 'Forma',
                    sortable: false
                },
                {
                    key: 'closed',
                    label: 'Status',
                    sortable: false,
                    formatter: value => (value ? 'Pago' : 'Em Aberto')
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
                { key: 'accesses', label: 'Acesso', variant: 'secondary' }
            ],
            fieldsDocumentSettlement: [
                {
                    key: 'settlement_date',
                    label: 'Liquidado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'user_name', label: 'Por' },
                { key: 'cnpj_cpf', label: 'Banco/Caixa', sortable: false },
                { key: 'name_entity', label: 'Nome', sortable: false },
                {
                    key: 'conciliation_date',
                    label: 'Conciliado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                {
                    key: 'compensation_date',
                    label: 'Compensado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        searchglobal() {
            return this.$store.state.searchglobal
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.releases.length
        }
    },
    methods: {
        setDateToday() {
            this.release = {
                ...this.release,
                issue_date: moment
                    .utc()
                    .local()
                    .format('YYYY-MM-DD')
            }
        },
        formatDateTime(date) {
            return moment.parseZone(date).format('YYYY-MM-DD LT')
        },
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        finalValue() {
            return (this.releasesplot.final_value = parseFloat(
                this.releasesplot.portion_value -
                    (this.releasesplot.discount_value
                        ? this.releasesplot.discount_value
                        : 0) -
                    (this.releasesplot.advance_portion_value
                        ? this.releasesplot.advance_portion_value
                        : 0) +
                    +(this.releasesplot.fine_value
                        ? this.releasesplot.fine_value
                        : 0) +
                    +(this.releasesplot.interest_rate_value
                        ? this.releasesplot.interest_rate_value
                        : 0)
            ).toFixed(2))
        },
        showMsgBoxCancel() {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeRelease()
                    }
                })
        },
        showMsgBoxNotConfirm(release) {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Desconfirmar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.notConfirmRelease(release)
                    }
                })
        },
        showMsgBoxCanceled() {
            this.boxCanceled = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Cancelar a Liquidação ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCanceled = value
                    if (this.boxCanceled === true) {
                        await this.cancelSettlement()
                    }
                })
        },
        showMsgBoxAccounting() {
            this.boxAccount = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Recontabilizar o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-1',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxAccount = value
                    if (this.boxAccount === true) {
                        await this.reaccountingRelease()
                    }
                })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        apportionmentValue() {
            return (this.releasesapportionment.apportionment_value = parseFloat(
                this.release.release_value *
                    ((this.releasesapportionment.apportionment_percent
                        ? this.releasesapportionment.apportionment_percent
                        : 0) /
                        100)
            ).toFixed(2))
        },
        async cancelSettlement() {
            this.documentsettlement.canceled = true
            this.documentsettlement.user_canceled_id = this.user.id
            this.documentsettlement.canceled_date = this.formatDateTime(Date())

            const method = 'put'
            const id = `/${this.documentsettlement.id}`
            await axios[method](
                `${baseApiUrl}/documentsettlements${id}`,
                this.documentsettlement
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async loadReleases() {
            const url = `${baseApiUrl}/releasessearchdate/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.document_status_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&release_number=${this.release_number}`
            await axios.get(url).then(res => {
                this.releases = res.data
                this.isBusy = false
            })
        },
        async loadContracts() {
            const url_value = `${baseApiUrl}/contractallowvalue/${this.company_id}`
            await axios.get(url_value).then(res => {
                this.contractsitemvalues = res.data
            })
            const url_quantity = `${baseApiUrl}/contractallowquantity/${this.company_id}`
            await axios.get(url_quantity).then(res => {
                this.contractsitemquantitys = res.data
            })
        },
        async validatedValueSplot(release) {
            this.release = { ...release }

            await axios
                .get(`${baseApiUrl}/releasesplotsgettotal/${this.release.id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadReleases()
                })
                .catch(showError)
        },
        async unblocked(releasesplot) {
            const id = releasesplot.id
            await axios
                .put(`${baseApiUrl}/unblockedreleasespot/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async blocked(releasesplot) {
            const id = releasesplot.id
            await axios
                .put(`${baseApiUrl}/blockedreleasespot/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async notConfirmRelease(release) {
            this.release = { ...release }

            await this.existsReleaseSplotClosed(release.id)

            if (this.releasesplotclosed) {
                this.$toasted.global.defaultWarning({
                    msg:
                        'Existe parcela Liquidada deste lançamento!Não pode ser desconfirmado...'
                })
            } else {
                if (!this.compan.accounting_period_start) {
                    this.$toasted.global.defaultWarning({
                        msg: 'Empresa sem definição de Período Contábil'
                    })
                } else {
                    if (
                        this.formatDate(this.compan.accounting_period_start) >
                        this.formatDate(this.release.issue_date)
                    ) {
                        this.$toasted.global.defaultWarning({
                            msg: 'Data esta fora do período contábil'
                        })
                    } else if (
                        this.formatDate(this.compan.accounting_period_end) <
                        this.formatDate(this.release.issue_date)
                    ) {
                        this.$toasted.global.defaultWarning({
                            msg: 'Data esta fora do período contábil'
                        })
                    } else {
                        if (this.release.id) {
                            this.release.user_update_id = this.user.id
                            this.release.update_date = this.formatDate(
                                moment.utc().local()
                            )
                            this.release.document_status_id = 1

                            const method = this.release.id ? 'put' : 'post'
                            const id = this.release.id
                                ? `/${this.release.id}`
                                : ''
                            await axios[method](
                                `${baseApiUrl}/releases${id}`,
                                this.release
                            )
                                .then(async () => {
                                    await this.loadReleases()
                                    this.$toasted.global.defaultSuccess()
                                })
                                .catch(showError)
                        }
                    }
                }
            }
        },
        async removeRelease() {
            const id = this.release.id

            await axios
                .delete(`${baseApiUrl}/releases/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async AccountingRelease(release) {
            const id = release.id
            await axios
                .get(`${baseApiUrl}/accountingentrys/${id}`)
                .then(res => {
                    this.accountingentrys = res.data
                })
        },
        loadOperation() {
            const url = `${baseApiUrl}/operations`
            axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation
                    }
                })
            })
            this.$refs.inputsearch.focus()
        },
        async setEntity() {
            const url = `${baseApiUrl}/entitys/${this.entity_id}`
            await axios(url).then(res => (this.entity = res.data))
        },
        async setEntityTypeRelease() {
            const url = `${baseApiUrl}/entitys/${this.release.entity_id}`
            await axios(url).then(res => (this.entitytype_entity = res.data))
        },
        async existsReleaseSplotClosed(id) {
            const url = `${baseApiUrl}/releasesplotexistsclosed/${id}`
            await axios(url).then(res => (this.releasesplotclosed = res.data))
        },
        setRelease(release) {
            this.release.id = release.id
        },
        actionEditRelease(release) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
                operation_release: this.operation_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (release.issue_date)
                release.issue_date = this.formatDate(release.issue_date)
            if (release.release_date)
                release.release_date = this.formatDate(release.release_date)

            this.$router.push({
                name: 'Recordrelease',
                query: { releasebase: release }
                //params: {id: release.id}
            })
        },
        async loadDocumentStaus() {
            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                this.documentstatus = res.data.map(documentstatu => {
                    return {
                        value: documentstatu.id,
                        text: documentstatu.name_document_status
                    }
                })
            })
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        actionNewRelease() {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
                operation_release: this.operation_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                const release = {}
                release.document_status_id = 1
                release.checkvalueplot = 0
                this.$router.push({
                    name: 'Recordrelease',
                    query: { releasebase: release }
                    //params: {id: release.id}
                })
            }
        },
        async printerRelease() {
            if (!this.start_date || !this.end_date) {
                this.$toasted.global.defaultWarning({
                    msg: 'Data não informada'
                })
            } else if (!this.company_id) {
                this.$toasted.global.defaultWarning({
                    msg: 'Empresa não informada'
                })
            } else if (!this.operation_id) {
                this.$toasted.global.defaultWarning({
                    msg: 'Operação não informada'
                })
            } else {
                const url = `${baseApiUrl}/releasessearchdatestatusprinter/${this.company_id}/?start_date=${this.start_date}&end_date=${this.end_date}&status_id=${this.document_status_id}&operation_id=${this.operation_id}&entity_id=${this.entity_id}&cost_center_id=${this.cost_center_id}&operation_level_one_id=${this.operation_level_one_id}&operation_level_two_id=${this.operation_level_two_id}`
                await axios.get(url)
                window.open(url)
            }
        },
        async printerReleaseOperation() {
            if (!this.start_date || !this.end_date) {
                this.$toasted.global.defaultWarning({
                    msg: 'Data não informada'
                })
            } else if (!this.company_id) {
                this.$toasted.global.defaultWarning({
                    msg: 'Empresa não informada'
                })
            } else {
                const url = `${baseApiUrl}/releaseoperationprinter/?company_id=${this.company_id}&start_date=${this.start_date}&end_date=${this.end_date}&cost_center_id=${this.cost_center_id}`
                await axios.get(url)
                window.open(url)
            }
        },
        actionEditDocumentEntry(release) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
                operation_release: this.operation_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            this.$router.push({
                name: 'RecordDocumentEntry',
                //query: { documententrybase: this.documententry }
                params: { id: release.document_entry_id }
            })
        },
        setReleaseAccount(release) {
            this.release = { ...release }
        },
        async reaccountingRelease() {
            if (this.compan.require_account_entry === 1) {
                if (this.release.document_status_id === 2) {
                    await axios['post'](
                        `${baseApiUrl}/accountingrelease`,
                        this.release
                    )
                        .then(async () => {
                            await this.accountingReleaseRetention()
                            await this.loadReleases()
                            this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
                }
            } else {
                this.$toasted.global.defaultWarning({
                    msg:
                        'Empresa não está configurada para usar a contabilização de lançamento.'
                })
            }
        },
        async accountingReleaseRetention() {
            if (this.release.document_status_id === 2) {
                await axios['post'](
                    `${baseApiUrl}/accountingreleaseretention`,
                    this.release
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            }
        },
        async documentSettlementRelease(releasesplot) {
            const id = releasesplot.id
            await axios
                .get(
                    `${baseApiUrl}/releasesplotbydetaildocumentsettlement/${id}`
                )
                .then(res => {
                    this.documentsettlements = res.data
                })
        },
        async loadCostCenter() {
            const url = `${baseApiUrl}/costcenteranalitic/${this.company_id}`
            await axios.get(url).then(res => {
                this.costcenters = res.data.map(costcenter => {
                    return {
                        value: costcenter.id,
                        text: costcenter.name_cost_center
                    }
                })
            })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        async loadTypeReleases() {
            const url = `${baseApiUrl}/typereleases`
            await axios.get(url).then(res => {
                this.typereleases = res.data.map(typerelease => {
                    return {
                        value: typerelease.id,
                        text: typerelease.name_type_release
                    }
                })
            })
        },
        async loadTypeRelease() {
            const url = `${baseApiUrl}/typereleases/${this.release.type_release_id}`
            await axios.get(url).then(res => {
                this.typerelease = { ...res.data }
            })
        },
        async loadConditionPaymentReceipt() {
            const url = `${baseApiUrl}/conditionpaymentreceipts`
            await axios.get(url).then(res => {
                this.conditionpaymentreceipts = res.data.map(
                    conditionpaymentreceipt => {
                        return {
                            value: conditionpaymentreceipt.id,
                            text:
                                conditionpaymentreceipt.name_condition_payment_receipt
                        }
                    }
                )
            })
        },
        async loadSettlementForms() {
            const url = `${baseApiUrl}/settlementforms`
            await axios.get(url).then(res => {
                this.settlementforms = res.data.map(settlementform => {
                    return {
                        value: settlementform.id,
                        text: settlementform.name_settlement_form
                    }
                })
            })
        },
        async getLastdocumentSettlement() {
            const url = `${baseApiUrl}/documentsettlementslastid/${this.documentsettlement.release_plot_id}`
            await axios(url).then(
                res => (this.documentsettlement = { ...res.data })
            )
        },
        async setTypeReleaseRelease() {
            this.release = {
                type_release_id: this.typerelease.id,
                release_date: moment
                    .utc()
                    .local()
                    .format('YYYY-MM-DD'),
                entity_id: this.typerelease.entity_id,
                type_document_id: this.typerelease.type_document_id,
                type_cost_id: this.typerelease.type_cost_id,
                operation_id: this.typerelease.operation_id,
                condition_payment_receipt_id: this.typerelease
                    .condition_payment_receipt_id,
                settlement_form_id: this.typerelease.settlement_form_id,
                company_id: this.compan.id,
                user_id: this.user.id
            }
            await this.setEntityTypeRelease()
        },
        actionNewReleaseContract(contract) {
            this.searchsetparms = {}
            this.$store.commit('setSearchGlobal', null)
            localStorage.removeItem(searchglobalkey)

            this.searchsetparms = {
                start_date_release: this.start_date,
                end_date_release: this.end_date,
                company_id_release: this.company_id,
                operation_release: this.operation_id
            }
            this.$store.commit('setSearchGlobal', this.searchsetparms)
            localStorage.setItem(
                searchglobalkey,
                JSON.stringify(this.searchsetparms)
            )

            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            } else {
                const release = {}
                release.document_status_id = 1
                release.checkvalueplot = 0
                release.contract_item_id = contract.id
                release.entity_id = contract.contract_entity_id
                release.name_entity = contract.name_entity
                release.cnpj_cpf = contract.cnpj_cpf
                release.condition_payment_receipt_id =
                    contract.contract_item_condition_payment_receipt_id
                release.contract_item_control_quantity =
                    contract.contract_item_control_quantity
                if (contract.contract_item_control_quantity) {
                    release.release_value = contract.contract_item_value_unit
                }

                this.$router.push({
                    name: 'Recordrelease',
                    query: { releasebase: release }
                    //params: {id: release.id}
                })
            }
        },
        setSearchEntity() {
            this.hideModal()
        },
        hideModal() {
            this.$bvModal.hide('modalEntity')
        },
        openModalEntity() {
            this.$bvModal.show('modalEntity')
        },
        setSearchEntityTypeEntity() {
            this.release = { ...this.release, entity_id: this.entity_id }
            this.setEntityTypeRelease()
        },
        async reaccountingReleaseSpot() {
            if (this.compan.require_account_entry === 1) {
                await axios['post'](
                    `${baseApiUrl}/accountingreleasesplot`,
                    this.documentsettlement
                )
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.loadReleases()
                    })
                    .catch(showError)
            }
        },
        async saveNewRelease() {
            if (!this.compan) {
                this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
            }

            const method = 'post'
            await axios[method](
                `${baseApiUrl}/newreleasetyperelease`,
                this.release
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        setNewApportionment(item) {
            this.releasesapportionment = {}
            this.releasesapportionment.apportionment_operation_id =
                item.operation_id
            this.releasesapportionment.company_id = item.operation_id
        },
        async loadAppontOperationsLevelOnes(item) {
            const url = `${baseApiUrl}/operationslevelones/${item.operation_id}/operations`
            await axios.get(url).then(res => {
                this.operationslevelones = res.data.map(operationslevelone => {
                    return {
                        value: operationslevelone.id,
                        text: operationslevelone.name_operation_level_one
                    }
                })
            })
        },
        async loadAppontOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.releasesapportionment.apportionment_operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return {
                        value: operationsleveltwo.id,
                        text: operationsleveltwo.name_operation_level_two
                    }
                })
            })
        },
        loadAppontCostCenter(item) {
            const url = `${baseApiUrl}/costcenteranalitic/${item.company_id}`
            axios.get(url).then(res => {
                this.costcenters = res.data.map(costcenter => {
                    return {
                        value: costcenter.id,
                        text: costcenter.name_cost_center
                    }
                })
            })
        },
        loadTypeCost() {
            const url = `${baseApiUrl}/typecosts`
            axios.get(url).then(res => {
                this.typecosts = res.data.map(typecost => {
                    return { value: typecost.id, text: typecost.name_type_cost }
                })
            })
        },
        async savePlot() {
            this.releasesplot.user_update_id = this.user.id
            this.releasesplot.update_date = this.formatDate(moment.utc())

            const method = this.releasesplot.id ? 'put' : 'post'
            const id = `/${this.releasesplot.id}`
            await axios[method](
                `${baseApiUrl}/releasesplots${id}`,
                this.releasesplot
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadReleases()
                })
                .catch(showError)
        },
        async saveApportionment() {
            if (this.releasesapportionment.id) {
                this.releasesapportionment.user_update_id = this.user.id
                this.releasesapportionment.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.releasesapportionment.user_id = this.user.id
            }
            const method = this.releasesapportionment.id ? 'put' : 'post'
            const id = this.releasesapportionment.id
                ? `/${this.releasesapportionment.id}`
                : ''

            await axios[method](
                `${baseApiUrl}/releasesapportionments${id}`,
                this.releasesapportionment
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadreleasesApportionments()
                })
                .catch(showError)
        },
        async loadreleasesApportionments() {
            const id = this.releasesapportionment.apportionment_release_id
            const url = `${baseApiUrl}/releasesapportionment/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesapportionments = res.data
            })
        },
        async loadreleasesPlots() {
            const id = this.releasesplot.release_id
            const url = `${baseApiUrl}/releasesplots/${id}/releases`
            await axios.get(url).then(res => {
                this.releasesplots = res.data
            })
        },
        loadreleasesApportionment(releasesapportionment) {
            this.releasesapportionment = { ...releasesapportionment }
            this.loadAppontOperationsLevelTwos()
        },
        loadReleasesPlot(releasesplot) {
            if (releasesplot.due_date)
                releasesplot.due_date = this.formatDate(releasesplot.due_date)
            if (releasesplot.scheduled_date)
                releasesplot.scheduled_date = this.formatDate(
                    releasesplot.scheduled_date
                )

            this.releasesplot = { ...releasesplot }
        },
        loadSettlement(releasesplot) {
            const datenow = new Date()
            this.documentsettlement = {}
            this.documentsettlement.settlement_date = this.formatDate(datenow)
            this.documentsettlement.release_plot_id = releasesplot.id
            this.documentsettlement.settlement_value = releasesplot.final_value
            this.documentsettlement.user_id = this.user.id
            this.documentsettlement.company_id = this.company_id
        },
        async loadEntitySettlements() {
            const url = `${baseApiUrl}/entitysettement/${this.company_id}`
            await axios.get(url).then(res => {
                this.entitysettlements = res.data.map(entitysettlement => {
                    return {
                        value: entitysettlement.id,
                        text: `${entitysettlement.name_entity} - ${entitysettlement.cnpj_cpf}`
                    }
                })
            })
        },
        async saveSettlement() {
            const method = 'post'
            await axios[method](
                `${baseApiUrl}/documentsettlements`,
                this.documentsettlement
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    if (this.compan.require_account_entry === 1) {
                        await this.getLastdocumentSettlement()
                        await this.reaccountingReleaseSpot()
                    }
                    await this.loadreleasesPlots()
                })
                .catch(showError)
        },
        async loadSettlementReleaseSplot(releasesplot) {
            this.documentsettlement = {}
            this.releasesplot.final_value = releasesplot.final_value
            this.documentsettlement.release_plot_id = releasesplot.id

            const url = `${baseApiUrl}/documentsettlementsreleasesplots/${releasesplot.id}`
            await axios.get(url).then(res => {
                this.documentsettlement = res.data
            })
        },
        openModalOperation(item) {
            this.loadAppontCostCenter(item)
            this.loadTypeCost()
            this.releasesapportionment = {}
            this.releasesapportionment.apportionment_release_id = item.id
            this.releasesapportionment.apportionment_operation_id =
                item.operation_id
            this.loadAppontOperationsLevelOnes(item)
            this.loadreleasesApportionments()
            this.$bvModal.show('modalOperations')
        },
        openModalSplot(item) {
            this.releasesplot.release_id = item.id
            this.loadreleasesPlots()
            this.$bvModal.show('modalSplotSearch')
        }
    },
    mounted() {
        this.loadOperation()
        this.loadCompanys()
        this.loadDocumentStaus()
        this.loadConditionPaymentReceipt()
        this.loadSettlementForms()

        //this.loadTypeReleases()

        if (this.searchglobal) {
            this.start_date = moment(
                this.searchglobal.start_date_release
            ).format('YYYY-MM-DD')
            this.end_date = moment(this.searchglobal.end_date_release).format(
                'YYYY-MM-DD'
            )
            this.company_id = this.searchglobal.company_id_release
            this.operation_id = this.searchglobal.operation_release
        } else {
            this.start_date = moment()
                .startOf('month')
                .format('YYYY-MM-DD')
            this.end_date = moment()
                .endOf('month')
                .format('YYYY-MM-DD')
            this.company_id = this.compan.id
        }

        if (!this.compan) {
            this.$toasted.global.defaultWarning({ msg: 'Logar na Empresa' })
        }

        this.loadReleases()
        this.showTable = true
    }
}
</script>

<style>
.sub-background {
    background: linear-gradient(to top, #bdc3c7, #e7ebee);
    border-radius: 35px;
}

.release-search {
    font-size: 0.7rem;
}

.release-search input,
label,
form {
    font-size: 0.7rem;
}
.release-search button {
    font-size: 0.7rem;
}

.release-search select {
    font-size: 0.7rem;
}

.release-search table {
    font-size: 0.7rem;
}

#modalAccounting {
    font-size: 0.7rem;
}

#modalAccounting button {
    font-size: 0.7rem;
}
#modalAccounting input,
label,
form {
    font-size: 0.7rem;
}

#modalContract {
    font-size: 0.7rem;
}

#modalContract button {
    font-size: 0.7rem;
}
#modalContract input,
label,
form {
    font-size: 0.7rem;
}

#modalTypeRelease {
    font-size: 0.7rem;
}

#modalTypeRelease select {
    font-size: 0.7rem;
}

#modalTypeRelease button {
    font-size: 0.7rem;
}
#modalTypeRelease input,
label,
form {
    font-size: 0.7rem;
}

#modalEntityTypeRelease {
    font-size: 0.7rem;
}

#modalEntityTypeRelease select {
    font-size: 0.7rem;
}

#modalEntityTypeRelease button {
    font-size: 0.7rem;
}

#modalOperations {
    font-size: 0.7rem;
}

#modalOperations button {
    font-size: 0.7rem;
}

#modalApportionment {
    font-size: 0.7rem;
}

#modalApportionment select,
label {
    font-size: 0.7rem;
}

#modalApportionment input {
    font-size: 0.7rem;
}

#modalApportionment button {
    font-size: 0.7rem;
}

#modalSplotSearch {
    font-size: 0.7rem;
}

#modalSplotSearch button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
